import { FormWithRedux } from '../../FormWithRedux';

export class GPChestPainPathwayInformationForm extends FormWithRedux {

    constructor() {
        super('pathwayInformationForm');
    }

    shouldDisplayFormDetailForIdentifier() {
        return true;
    }

    isEnabled(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    isMandatory() {
        return false;
    }

    getValueType() {
        return null;
    }

    submissionValidation() {
        return [];
    }

    detailString() {
        return this.detail;
    }
}


// WEBPACK FOOTER //
// ./src/forms/gpChestPain01/Forms/GPChestPain-PathwayInformationForm.js